import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "../styles/faq.css";

const faqs = [
  {
    question: "Hol található a rendelő?",
    answer:
      "Rendelőnk Szolnok belvárosában található, jól megközelíthető helyen. A környéken fizetős parkolási lehetőség áll rendelkezésre.",
  },
  {
    question: "Kell időpontot foglalni a kezeléshez?",
    answer:
      "Igen, a betegellátás előjegyzés alapján történik. Kérjük, időpontját előzetesen online vagy telefonon foglalja le.",
  },
  {
    question: "Fájdalmas a fogtömés?",
    answer:
      "A kezelést helyi érzéstelenítésben végezzük, így a fogtömés fájdalommentes.",
  },
  {
    question: "Mire számíthatok az első alkalommal?",
    answer:
      "Az első alkalom során részletes állapotfelmérés, szükség esetén panoráma röntgen, valamint személyre szabott kezelési terv készül.",
  },
  {
    question: "Készítenek röntgenfelvételt helyben?",
    answer:
      "Igen, rendelőnkben kis röntgen, panoráma röntgen, teleröntgen és CBCT felvételek készítésére is lehetőség van.",
  },
  {
    question: "Hogyan történik a fogfehérítés?",
    answer:
      "A fogfehérítés professzionális anyaggal és lámpás technológiával történik, gyorsan és biztonságosan. Emellett egyénre szabott otthoni fogfehérítő síneket is készítünk.",
  },
  {
    question: "Mennyi ideig tart egy fogkő-eltávolítás?",
    answer:
      "Átlagosan 30–45 percet vesz igénybe, a fogkő mennyiségétől függően.",
  },
  {
    question: "Milyen fizetési lehetőségek állnak rendelkezésre?",
    answer:
      "Készpénzes, bankkártyás, valamint egészségpénztári kártyás fizetés is elérhető szerződött partnereinknél.",
  },
  {
    question: "Szükséges kontrollvizsgálatra járni?",
    answer:
      "Igen, a rendszeres kontrollvizsgálat a megelőzés érdekében szükséges. Nagyobb rehabilitációk kizárólag abban az esetben garanciálisak, amennyiben a páciens megjelenik az orvos által javasolt kontrollvizsgálatokon.",
  },
];

const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faq-section">
      <h2 className="faq-title" data-aos="fade-up">
        Mindenben segítünk
      </h2>
      <div className="faq-list">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className={`faq-item ${openIndex === index ? "open" : ""}`}
            onClick={() => toggle(index)}
            data-aos="fade-up"
            data-aos-delay={index * 100}
          >
            <div className="faq-question">
              <span className="faq-text">{faq.question}</span>
              <span className="faq-icon">
                {openIndex === index ? "−" : "+"}
              </span>
            </div>
            {openIndex === index && (
              <div className="faq-answer" data-aos="fade-in">
                {faq.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FaqSection;
